module.exports = __webpack_public_path__ + "static/img/莲藕健康LOGO@2x.560725c7.png";